<template>
    <div ref="categoryFilter">
        <div id="sidebar-category-filter" />
    </div>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'

const categoryFilter = ref<null | HTMLElement>(null)
const headerElement = ref<null | HTMLElement>(null)
const footerElement = ref<null | HTMLElement>(null)
const lastScrollTop = ref(0)

const { height: windowHeight } = useWindowSize()
const isWindowHigh = computed(() => {
    return windowHeight.value > 900
})
let resizeObserver: ResizeObserver | null = null

onMounted(async () => {
    setTimeout(() => {
        initStickySidebar()
        resizeObserver = new ResizeObserver(() => {
            onHeightChange()
        })
        if (categoryFilter.value != null) {
            resizeObserver.observe(categoryFilter.value)
        }
    }, 300)
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleNavigationScrollBehaviour)
    if (categoryFilter.value != null && resizeObserver != null) {
        resizeObserver.unobserve(categoryFilter.value)
    }
})

function initStickySidebar () {
    if (categoryFilter.value?.offsetHeight == null || categoryFilter.value?.parentElement?.offsetHeight == null) {
        return
    }

    headerElement.value = document.querySelector('header')
    footerElement.value = document.querySelector('footer')

    if (headerElement?.value?.clientHeight != null && (categoryFilter.value?.parentElement?.offsetHeight + headerElement?.value?.clientHeight) >= window.innerHeight) {
        categoryFilter.value.classList.add('overflow-hidden', 'h-[100vh]')
        window.addEventListener('scroll', handleNavigationScrollBehaviour)
    }

    categoryFilter.value.parentElement.style.position = 'sticky'
    categoryFilter.value.parentElement.style.top = '0'
    categoryFilter.value.classList.remove('pt-16')
    categoryFilter.value.parentElement.parentElement?.classList.add('pt-16')
}

function handleNavigationScrollBehaviour() {
    if (categoryFilter.value?.offsetHeight && footerElement.value?.offsetHeight) {
        const isScrollAboveFooter = footerElement.value.getBoundingClientRect().top > window.innerHeight
        const isScrollPositionTop = categoryFilter.value.getBoundingClientRect().top <= categoryFilter.value.offsetTop
        const currentScrollTop = window.scrollY
        if (isScrollPositionTop && isScrollAboveFooter) {
            let deltaScroll = lastScrollTop.value - currentScrollTop
            if (deltaScroll > 0 && isWindowHigh.value) {
                // slow down upward scroll movement on high windows
                // scrollTop must reach 0
                deltaScroll -= .7
            }
            categoryFilter.value.scrollTop -= deltaScroll
        }
        lastScrollTop.value = currentScrollTop
    }
}

function onHeightChange () {
    window.removeEventListener('scroll', handleNavigationScrollBehaviour)
    initStickySidebar()
}
</script>
